module.exports = __webpack_public_path__ + "static/media/nav_jj_jr_bg.abc602d9.png";